import axiosClient from "../../../../../../api/axiosClient";

const warehouseLookupService = {
  search: async () => {
    const res = await axiosClient.get(
      "/api/ppe/material-flow/warehouse/master/list"
    );

    return res.data?.data || [];
  },
};

export default warehouseLookupService;